import { useQuery } from '@tanstack/react-query'
import { getLibrary } from '@/api/lcLearning'

export const learnerLibraryQueryKey = ['learner', 'me', 'library'] as const

interface UseLearnerLibraryOptions {
  enabled?: boolean
}

export function useLearnerLibrary({ enabled = true }: UseLearnerLibraryOptions = {}) {
  return useQuery({
    queryKey: learnerLibraryQueryKey,
    queryFn: getLibrary,
    enabled,
    staleTime: 0,
  })
}
